import http from "infra/http";
import { useMutation } from "react-query";
import { FornecedorImposto } from 'core/features/fornecedores/typings/index';

function usePutImposto(id?: string) {
    return useMutation(
        `/v1/fornecedor${id}/imposto`,
        (data: FornecedorImposto) => {

            return http.put<{ id: string }>(
                `/v1/fornecedor/${id}/imposto`,
                data
            );
        },
        { retry: false }
    );
}

export default usePutImposto;
